var _style, _g, _tspan, _tspan2, _tspan3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVmsProLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vms-pro-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #0b3c5d } \n\t\t.s1 { fill: #d9b310 } \n\t\t.s2 { fill: #ffffff } \n\t\t.t3 { font-size: 36px;fill: #0b3c5d;font-family: \"Arial\" } \n\t\t.t4 { font-size: 36px;fill: #d9b310;font-family: \"Arial\" } \n\t\t.t5 { font-size: 14px;fill: #4a6a80;font-family: \"Arial\" } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m54 82c-17.7 0-32-14.3-32-32 0-17.7 14.3-32 32-32 17.7 0 32 14.3 32 32 0 17.7-14.3 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m36 50h36c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2h-36c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m45 58h18c0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1h-18c-0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m45 42h18c0.6 0 1 0.4 1 1 0 0.6-0.4 1-1 1h-18c-0.6 0-1-0.4-1-1 0-0.6 0.4-1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m68 48h-8c-0.6 0-1 0.4-1 1v2c0 0.6 0.4 1 1 1h8c0.6 0 1-0.4 1-1v-2c0-0.6-0.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m61 56c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s1",
    d: "m67 56c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2 1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2z"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "VMS",
    style: {
      transform: "matrix(1,0,0,1,108,56)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t3"
  }, "VMS\n"))), /*#__PURE__*/React.createElement("text", {
    id: "Pro",
    style: {
      transform: "matrix(1,0,0,1,198,56)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t4"
  }, "Pro\n"))), /*#__PURE__*/React.createElement("text", {
    id: "Vehicle Management System Professional",
    style: {
      transform: "matrix(1,0,0,1,110,78)"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "t5"
  }, "Vehicle Management System Professional\n"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmsProLogo);
export default __webpack_public_path__ + "static/media/vms-pro-logo.2465c93eb67a4f644d3e2e39cbfb1cfb.svg";
export { ForwardRef as ReactComponent };